var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid position-relative p-4 h-100"},[_c('h2',[_vm._v("Verlauf")]),_c('b-table',{attrs:{"striped":"","hover":"","items":this.$root.log,"sort-by":"time","sort-desc":"","fields":_vm.log_table_fields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }